<template>
	<div>

		<div class="display_msg pos_inherit" grey-back v-if="!listItemObject.totalCount">There are no activities!</div>

		<div v-scroll="onScroll">

			<v-list grey-back three-line nopadding v-if="listItemObject.totalCount">

				<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.transactionId">
					<v-list-tile class="right-subtitle-tile auto-height-tile" @click="fn_itemClick(item, index)">
					    <v-list-tile-content>
					      <!-- <v-list-tile-title class="mb-1">{{fn_transactionName(item.transactionListId)}}</v-list-tile-title> -->
                          <v-list-tile-title class="mb-1">
							<template v-if="item.transactionListId == 10003">{{item.partyName ? item.partyName : 'Cash Sale'}}</template>
							<template v-else>{{item.partyName}}</template>
						  </v-list-tile-title>
                          <v-list-tile-sub-title class="mb-1">{{fn_transactionName(item.transactionListId)}} | <span v-if="item.mergeTransactionNumber" class="primary-color"> {{item.mergeTransactionNumber}}</span> <template v-if="item.mergeTransactionNumber">|</template> {{fn_transactionDate(item.transactionListId, item.transactionDate)}}</v-list-tile-sub-title>
					      <v-list-tile-sub-title v-for="(unit, unitIndex) in item.unitReferenceItems" :key="unitIndex">
							<!-- // <template v-for="(unit, unitIndex) in item.unitReferenceItems">
                            //     {{ unit.qty }} {{ unit.unitName }}<template v-if="unitIndex != item.unitReferenceItems.length - 1">,</template>
                            // </template> -->
							{{ unit.qty }} {{ unit.unitName }}
                            <span v-if="unit.rate">| &#8377; {{unit.rate}} ({{item.unitName}})</span>
					      </v-list-tile-sub-title>
					    </v-list-tile-content>

					    <v-list-tile-action style="position: absolute;bottom: 2px;right: 16px;">
							<div></div>
                            <div  v-if="item.transactionListId != 40005">&#8377; {{$root.numberToLocale(item.taxableValue)}}</div>
					    	<!-- <div></div>
					    	<div>&#8377; {{$root.numberToLocale(item.taxableValue)}}</div> -->
					    	<!-- <div class="warning-label" v-if="!item.status">Cancelled</div> -->
					    	<!-- <div v-else></div> -->
					    </v-list-tile-action>
					</v-list-tile>

                    <template v-if="item.referenceItems && item.referenceItems.length">
                        <div style="background: aliceblue;padding:4px 16px;">
                            <v-list-tile-sub-title @click="fn_itemClick(ref, index)" class="mt-1" v-for="(ref, refIndex) in item.referenceItems" :key="refIndex">
                                {{fn_transactionName(ref.transactionListId)}} <span class="primary-color">{{ref.mergeTransactionNumber}}</span> | {{fn_transactionDate(ref.transactionListId, ref.transactionDate)}}
                            </v-list-tile-sub-title>
                        </div>
                    </template>

					<v-divider v-if="item.invoiceTemplate || item.transactionListId == 40005 || item.transactionListId == 40006"></v-divider>
					<div right-align style="padding:2px 6px;position:relative" v-if="item.invoiceTemplate || item.transactionListId == 40005 || item.transactionListId == 40006">
                        <div class="warning-label" v-if="!item.status">Cancelled</div>
						<v-btn nomargin icon flat @click="bindInvoiceTemplate('thermal', item)" v-if="$root.ThermalPrintSettings && $root.ThermalPrintSettings.enableThermalPrint && (getFormNameByListId(item.transactionListId) == 'Sale' || getFormNameByListId(item.transactionListId) == 'Receipt' || getFormNameByListId(item.transactionListId) == 'Payment')"><v-icon font20>receipt</v-icon></v-btn>
						<v-btn nomargin icon flat @click="bindInvoiceTemplate('sharewhatsapp', item)"><img src="../../../../../assets/icon_whatsapp.svg" style="width:20px" alt="whatapp_icon"></img></v-btn>
						<v-btn nomargin icon flat @click="bindInvoiceTemplate('share', item)"><v-icon font20>share</v-icon></v-btn>
				    	<v-btn nomargin icon flat @click="bindInvoiceTemplate('print', item)"><v-icon font20>print</v-icon></v-btn>
				    	<v-btn nomargin icon flat @click="preview(item, fn_transactionName)">
				    		<img src="../../../../../assets/icon_preview_black.svg" style="width:20px" alt="whatapp_icon"></img>
				    	</v-btn>
				    </div>

					<!-- <v-divider v-if="listItemObject.items.length-1 != index"></v-divider> -->
				</div>

			</v-list>

			<div padding-all-16 center-align>
				<v-progress-circular indeterminate color="primary" v-if="loadMore"></v-progress-circular>
			</div>
		</div>
	</div>
</template>

<script>

const transactionForms = require('../../../../../config.js').configs.transactionForms;

	export default{
		props:['productId', 'preview', 'bindInvoiceTemplate', 'getFormNameByListId'],
		data(){
			return{
				listItemObject:{"items":[], "totalCount":0},
				searchValue:'',
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				loadMore: false
			}
		},
		methods:{

			fn_transactionDate: function(listId, transactionDate){
				if(listId != 40001){
					return this.$moment(transactionDate).format('DD-MMM-YYYY');	
				}
				else{
					return this.$moment(this.$root.CurrentBusiness.OpeningDate).format('DD-MMM-YYYY');					
				}
			},

			onScroll: function(event){
				var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 20 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount){
			        	this.fn_loadItems();
			        }
			    }
			},

			fn_transactionName: function(transactionListId){
				for(let i=0; i<transactionForms.length; i++){
					if(transactionForms[i].id == transactionListId){
						return transactionForms[i].title;
					}
				}
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				if(menuAction=='edit'){
					this.$router.push('/transactions/sales/saleinvoice/items/'+this.selectedItemId+'/edit');
				}
			},

			fn_itemClick: function (item, index) {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("transaction_items_state", JSON.stringify(obj));

				this.$root.fn_navigateToDisplayView(item.transactionListId, item.transactionId);
				// this.$router.push('/transactions/sales/saleinvoice/items/'+itemId);
			},

			fn_getBottomMenu: function (elementId, itemId) {
				itemId ? this.selectedItemId = itemId : '';

				let bottomMenu;

				if(elementId == bottomSheetMenu.toolBar.Id){
					bottomMenu = {"BottomMenu": []};
				}
				else if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.edit]};
				}
				
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.productId = this.productId;
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue.toLowerCase();
				this.loading = true;

				let pageState = null;
				if(localStorage.getItem("transaction_items_state")){
					pageState = JSON.parse(localStorage.getItem("transaction_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				let self = this;
				this.getItems("StockTimeLineList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;

							for(let i in responseJson.items){

								if(responseJson.items[i].listItemData && responseJson.items[i].listItemData.length){
									let runningCustomer = responseJson.items[i].listItemData.filter(listItem=>{return listItem.listId == 'running_cash_transaction'});
									if(runningCustomer && runningCustomer.length){
										responseJson.items[i].partyName = runningCustomer[0].listItemData.partyName;
									}
								}

								let itemIndex = self.listItemObject.items.findIndex(item => item.transactionId==responseJson.items[i].transactionId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
								// self.listItemObject.items.push(responseJson.items[i]);	
							}

							console.log(pageState);
							// if(pageState && pageState.itemId){
							// 	setTimeout(function(){
							// 		let scrollOptions = {"duration":0, "offset":-56, "easing":"linear"};
							// 		self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
							// 		localStorage.removeItem("transaction_items_state");
							// 	},100);
							// }

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":-56, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("transaction_items_state");
								},100);
							}

							if(localStorage.getItem("scroll_top")){
								setTimeout(function(){
									let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(0, scrollOptions);
								},100);
							}

							// if(!pageState){
							// 	setTimeout(function(){
							// 		let scrollOptions = {"duration":300, "offset":0, "easing":"linear"};
							// 		self.$vuetify.goTo(0, scrollOptions);
							// 	},100);
							// }

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    }


		},
		mounted: function(){
			this.fn_loadItems();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/product/display_tabs/activity.vue